@if (batchForm && informationForm$ | async; as informationForm) {
  <div data-test="batch-configuration" class="col-7 spacing--margin-vertical">
    <h2 class="text--h3">{{ outcome$ | async }}</h2>
    @if (informationForm.cultivation) {
      <form [formGroup]="batchForm" [agrConnectForm]="batch$" (ngSubmit)="save()">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'batch-configuration.cultivation-method' | translate }}</mat-label>
          <input
            type="text"
            [placeholder]="'batch-configuration.cultivation-method' | translate"
            matInput
            formControlName="cultivationMethod"
            [matAutocomplete]="cultivationMethodAutocomplete"
            data-test="batch-configuration__cultivation-method"
          />
          <mat-autocomplete
            #cultivationMethodAutocomplete="matAutocomplete"
            [displayWith]="displayCultivationMethod"
          >
            @for (option of filteredCultivationMethods$ | async; track option) {
              <mat-option
                [value]="option"
                data-test="batch-configuration__cultivation-method-option"
              >
                {{ option.method }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (showSpecies$ | async) {
          <mat-form-field class="full-width-field">
            <mat-select
              placeholder="{{ 'batch-configuration.species' | translate }}"
              formControlName="species"
              data-test="batch-configuration__species"
            >
              @for (species of batchForm.controls.cultivationMethod.value.species; track species) {
                <mat-option [value]="species">
                  {{ species.species }}
                </mat-option>
              }
            </mat-select>
            @if (batchForm.controls.species.invalid) {
              <mat-error>
                {{ 'batch-configuration.error-species' | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'batch-configuration.hectares' | translate }}</mat-label>
          <input
            formControlName="hectares"
            matInput
            placeholder="Hectare"
            type="number"
            data-test="batch-configuration__hectares"
          />
          @if (batchForm.controls.hectares.invalid) {
            <mat-error>
              {{ 'batch-configuration.error-hectares' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <div class="pool-options-group" data-test="batch-configuration__pool-options">
          <mat-radio-group
            formControlName="isPool"
            class="pool-options-radio-group"
            data-test="batch-configuration__is-pool"
          >
            <mat-radio-button
              [value]="true"
              color="primary"
              data-test="batch-configuration__is-pool-option"
            >
              {{ 'batch-configuration.is-pool' | translate }}
            </mat-radio-button>
            <mat-radio-button
              [value]="false"
              color="primary"
              data-test="batch-configuration__is-pool-day-price"
            >
              {{ 'batch-configuration.is-pool-day-price' | translate }}
            </mat-radio-button>
          </mat-radio-group>

          @if (showDayPriceSubChoice$ | async) {
            <div
              class="dayprice-suboptions-group"
              data-test="batch-configuration__dayprice-suboptions"
            >
              <mat-radio-group
                formControlName="isDayPriceStorage"
                class="dayprice-suboptions-radio-group"
                data-test="batch-configuration__is-dayprice-storage"
              >
                <mat-radio-button
                  [value]="false"
                  color="primary"
                  data-test="batch-configuration__is-dayprice-direct"
                >
                  {{ 'batch-configuration.is-dayprice-direct' | translate }}
                </mat-radio-button>
                <mat-radio-button
                  [value]="true"
                  color="primary"
                  data-test="batch-configuration__is-dayprice-storage-option"
                >
                  {{ 'batch-configuration.is-dayprice-storage' | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          }
        </div>

        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isSelfContained"
            data-test="batch-configuration__is-self-contained"
            >{{ 'batch-configuration.is-self-contained' | translate }}</mat-slide-toggle
          >
        </div>
        @if (showIsPickUp$ | async) {
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="isPickUp"
              data-test="batch-configuration__is-pick-up"
              >{{ 'batch-configuration.is-pick-up' | translate }}</mat-slide-toggle
            >
          </div>
        }
        @if (showLocations$ | async) {
          <div>
            @if (deliveryLocations$ | async) {
              <div>
                <mat-form-field class="full-width-field">
                  <mat-label>{{ 'batch-configuration.delivery-location' | translate }}</mat-label>
                  <input
                    type="text"
                    [placeholder]="'batch-configuration.delivery-location' | translate"
                    matInput
                    formControlName="deliveryLocation"
                    [matAutocomplete]="deliveryLocationAutocomplete"
                    data-test="batch-configuration__location"
                  />
                  <mat-autocomplete
                    #deliveryLocationAutocomplete="matAutocomplete"
                    [displayWith]="displayDeliveryLocation"
                  >
                    @for (option of filteredDeliveryLocations$ | async; track option) {
                      <mat-option [value]="option" data-test="batch-configuration__location-option">
                        {{ option.locationDisplayName }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            }
          </div>
        }
        @if (showStorageTimeType$ | async) {
          <div>
            <label>{{ 'batch-configuration.storage-time-type' | translate }}</label>
            <mat-radio-group formControlName="storageTimeType">
              <mat-radio-button
                value="{{ StorageTimeType.short }}"
                data-test="batch-configuration__storage-time-type-short"
                >September of oktober</mat-radio-button
              >
              <mat-radio-button
                value="{{ StorageTimeType.long }}"
                data-test="batch-configuration__storage-time-type-long"
                >Januari – mei</mat-radio-button
              >
            </mat-radio-group>
            @if (batchForm.controls.storageTimeType.invalid) {
              <mat-error>
                {{ 'batch-configuration.error-storage-time-type' | translate }}
              </mat-error>
            }
          </div>
        }
        @if (showDeposit$ | async) {
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="isDeposit"
              data-test="batch-configuration__is-deposit"
              >{{ 'batch-configuration.is-deposit' | translate }}</mat-slide-toggle
            >
          </div>
        }
        @if (showIsHectareDeposit$ | async) {
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="isHectareDeposit"
              data-test="batch-configuration__is-hectare-deposit"
              >{{ 'batch-configuration.is-hectare-deposit' | translate }}</mat-slide-toggle
            >
          </div>
        }
        <div class="mat-button-row spacing--margin-vertical">
          <button mat-flat-button color="primary" type="submit">
            {{ 'save' | translate }}
          </button>
          <button mat-stroked-button (click)="cancel()" type="button">
            {{ 'cancel' | translate }}
          </button>
        </div>
      </form>
    }
  </div>
}
